import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { PreviewGateComponent } from './components/preview-gate/preview-gate.component';

@NgModule({
  declarations: [
    PreviewGateComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: [
    PreviewGateComponent
  ]
})
export class PreviewGateModule {
}

